<template>
  <div>
    <div v-if="!isAuthLv1" class="container">
      <div class="row justify-content-center">
        <div class="col-md-12 mt-5 text-center">
          <h3>Unauthorized</h3>
          <p>You do not have permission to view this page.</p>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div class="mt-3">
        <b-card no-body>
          <b-tabs pills card lazy>
            <!--
            <b-tab title="Create">
                <qrcode-create></qrcode-create>
              </b-tab>
              -->
            <b-tab title="Adjust Member">
              <gymcount></gymcount>
            </b-tab>
            <b-tab title="Ban Member">
              <ban-member></ban-member>
            </b-tab>
            <b-tab title="LINE Remove">
              <line-remove></line-remove>
            </b-tab>
            <b-tab title="Add FaceScan">
              <add-facescan></add-facescan>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
    <!-- ./container -->
  </div>
</template>
<script>
//import QrcodeCreate from "./QrcodeCreate.vue";
import { isAuthLv1 } from "./../js/utils/global.js";
import Gymcount from "./Gymcount.vue";
import BanMember from "./BanMember.vue";
import LineRemove from "./LineRemove.vue";
import AddFacescan from "./AddFacescan.vue";
//import Test from "./Test.vue";
export default {
  components: {
    //QrcodeCreate,
    Gymcount,
    BanMember,
    LineRemove,
    AddFacescan,
    //Test
  },
  data() {
    return {
      memberid: this.$route.params.id,
      loading: false,
      member: null,
    };
  },
  computed: {
    isAuthLv1() {
      return isAuthLv1();
    },
  },
  mounted() {},
  methods: {},
};
</script>
